<template>
  <div :class="$style.filterWrapper">
    <div
      v-if="filter.values.length > filterConfig.minValuesForSearch"
      :class="$style.searchBarWrapper"
    >
      <aw-input-version2
        v-model="filterKeyword"
        :widget-attrs="{
          placeholder: $awt('aw.product_list.filter.checkbox.search.placeholder'),
          'aria-label': $awt('aw.product_list.filter.checkbox.search.label'),
          placeholderFontWeight: 'Normal'
        }"
      />
      <div :class="$style.buttons">
        <lv-button
          v-if="!!filterKeyword"
          styling="link"
          :aria-label="$awt('aw.product_list.filter.checkbox.clear_button.label')"
          @click="clearTempFilterKeyword"
        >
          <lv-icon name="delete-16" :size="16" />
        </lv-button>
        <div v-else />
        <lv-button
          styling="small-primary-dark-just-icon"
          :aria-label="$awt('aw.product_list.filter.checkbox.search_button.label')"
        >
          <lv-icon name="search-16" :size="16" />
        </lv-button>
      </div>
    </div>
    <div :class="$style.checkBoxWrapper">
      <aw-checkbox-version2
        v-for="(item, j) in activeFilterValues"
        :key="`ch-${j}${checkBoxKey(filter, item)}`"
        v-model="localActiveFilters[filter.id]"
        :label="item.name"
        :value="item.value"
        has-label
        :class="$style.checkBox"
        @update:model-value="activateFilter({[filter.id]: item.value})"
      />
      <aw-separator
        v-if="activeFilterValues.length && inactiveFilterValues.length"
        margin-top="xs"
        margin-bottom="xs"
      />
      <aw-checkbox-version2
        v-for="(item, j) in inactiveFilterValues"
        :key="`ch-${j}${checkBoxKey(filter, item)}`"
        v-model="localActiveFilters[filter.id]"
        :label="item.name"
        :value="item.value"
        has-label
        :class="$style.checkBox"
        @update:model-value="activateFilter({[filter.id]: item.value})"
      />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import AwCheckboxVersion2 from '~~/common/components/Common/Widgets/AwCheckboxVersion2';
  import AwSeparator from '~~/common/components/Common/AwSeparator';
  import AwInputVersion2 from '~~/common/components/Common/AwInputVersion2.vue';
  import { LvButton, LvIcon } from '~~/common/components/loginet-vue-shop/index.mjs';
  import { useProductsStore } from '~~/common/stores/products';

  export default {
    name: 'CheckboxFilter',
    components: {
      LvIcon,
      LvButton,
      AwInputVersion2,
      AwSeparator,
      AwCheckboxVersion2,
    },
    props: {
      checkBoxKey: {
        type: Function,
        required: true,
      },
      filter: {
        type: Object,
        required: true,
      },
      activeFilters: {
        type: Object,
        required: true,
      },
      activateFilter: {
        type: Function,
        required: true,
      },
    },
    data () {
      return {
        filterConfig: {
          minValuesForSearch: 20,
        },
      };
    },
    computed: {
      ...mapState(useProductsStore, {
        storeFilterKeyword: state => state.filterKeyword,
      }),
      filterKeyword: {
        get () {
          const key = this.filter.id;
          return this.storeFilterKeyword?.[key] || '';
        },
        set (value) {
          const productsStore = useProductsStore();
          const key = this.filter.id;
          productsStore.setFilterKeyword(key, value);
        },
      },
      localActiveFilters: {
        get () {
          return this.activeFilters;
        },
        set () {
          // NOOP
        },
      },
      activeFilterValues () {
        return this.filter.values.filter(item => this.activeFilters[this.filter.id]?.includes(item.value));
      },
      inactiveFilterValues () {
        const filterKeyword = this.filterKeyword?.toLowerCase();
        return this.filter.values.filter(item => item.name.toLowerCase()?.includes(filterKeyword) && !this.activeFilters[this.filter.id]?.includes(item.value));
      },
    },
    methods: {
      clearTempFilterKeyword () {
        this.filterKeyword = '';
      },
    },
  };
</script>
<style module lang="scss" rel="stylesheet/scss">
.filterWrapper {
  .searchBarWrapper {
    position: relative;
    margin-bottom: 16px;

    .buttons {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      display: grid;
      align-items: center;
      justify-content: center;
      padding-right: 10px;
      grid-template-columns: repeat(2, 32px);
      gap: 10px;
    }

  }

  .checkBoxWrapper {
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    max-height: calc(10 * (24px + 12px));
    gap: 12px;

    &::-webkit-scrollbar {
      width: 12px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 36px;
      background: $color-background-4;
    }

    &::-webkit-scrollbar-thumb {
      border: 3px solid transparent;
      border-radius: 36px;
      background-color: $color-border-disabled;
      background-clip: content-box;

      &:hover, &:active {
        background-color: $color-border-disabled;
      }
    }
  }
}
</style>
